export const isCyrillic = (str) => {
  return /[а-яА-ЯЁё]/.test(str);
};
